import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import PriceInput from '../../PriceInput'

const deduceBlueprint = (blueprint, data) => {
  if (blueprint.inputs.length < 2 || !data.attributes) {
    return blueprint.inputs[0]
  }
  for (const input of blueprint.inputs) {
    if (data.attributes[input.id]) {
      return input
    }
  }
  return blueprint.inputs[0]
}

const AttributeSingleSelectPriceInput = ({
                                           blueprint,
                                           parentBlueprint,
                                           factsheetBlueprint,
                                           factInstanceKey,
                                           data,
                                           collapsed,
                                           putAttribute,
                                           deleteAttribute,
                                           putValidationStatus,
                                         }) => {
  const [selectedBlueprint, setSelectedBlueprint] = useState(deduceBlueprint(blueprint, data))
  const [selectedData, setSelectedData] = useState(
    data.attributes ? data.attributes[selectedBlueprint.id] : undefined
  )
  useEffect(() => {
    if (blueprint.inputs.length < 2 || !data.attributes) {
      return
    }
    const deducedBlueprint = deduceBlueprint(blueprint, data)
    setSelectedBlueprint(deducedBlueprint)
    setSelectedData(data.attributes[deducedBlueprint.id])
  }, [blueprint, data])
  return <PriceInput
    selectedBlueprint={selectedBlueprint}
    priceAttributeBlueprints={blueprint.inputs}
    parentBlueprint={parentBlueprint}
    factsheetBlueprint={factsheetBlueprint}
    factInstanceKey={factInstanceKey}
    data={selectedData}
    collapsed={collapsed}
    putAttribute={putAttribute}
    deleteAttribute={deleteAttribute}
    putValidationStatus={putValidationStatus}
    onChangeBlueprint={setSelectedBlueprint}
  />
}

AttributeSingleSelectPriceInput.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  data: PropTypes.object,
  collapsed: PropTypes.bool.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
}

export default AttributeSingleSelectPriceInput
